import { useOutletContext, useParams } from "react-router-dom"
import React, { useCallback, useEffect, useState } from "react";
import Paginate from "../../listAuction/paginate";
import ToastMeassage from "../../../../CommonComponent/toastMeasseage";
import { dataService } from "../../../../services/dataService";
import ListingHeader from "../../../../CommonComponent/ListingScreens/ListingHeader";
import ListingBody from "./ListingBody";
import scrollToTop from "../../../../CommonComponent/scrollToTop";
import Modal from "../../../../CommonComponent/Modal";
import { set } from "lodash";
import ErrorMessage from "../../../../CommonComponent/errorMessage";

export default function TelephoneBids(){

    const outletContext = useOutletContext();
    const {id, uid} = useParams();

    const { searchParam, setSearchParam, loading, setIsSearched,
        currentSortColumn, setCurrentSortColumn, auctionData,
        setSuccessMessage, setUploadErrorMessage, handleView } = outletContext;

    const [searchValue, setSearchValue]=useState("");
    const [showExoprtToastMsg, setShowExportToastMsg]=useState('')
    const [showErrorToastMsg, setShowErrorToastMsg]=useState('')
    const [bids,setBidss]=useState([])
    const [loadBids,setLoadBids]=useState(true);
    const [exportBtnLoading, setExportBtnloading] = useState(false)
    const [showExportModel, setShowExportModel] = useState(false)

    const getBids = useCallback(async (page) =>{
        setLoadBids(true)
        let endpoint = `per_page=${10}&page=${page ? page : '1'}`
    
        if(searchParam.get('sort')!==null){
            endpoint += `&sort_by=${String(searchParam.get('sort'))}&sort_order=${String
            (searchParam.get('order'))}`
        }
        if(searchParam.get('search_term')!==null){
            endpoint += `&search_keyword=${searchParam.get('search_term')}`
        }
        if(searchParam.get('bidsExport') !==null){
            endpoint += `&export=True`
        }
        const response = await dataService.GetLiveAuctionBids(uid, 'telephone', endpoint);
        setLoadBids(false)
        setBidss(response.data);
        setIsSearched(false)
        let params = Object.fromEntries(searchParam);
        delete params.bidsExport
        if(response.data?.csv_url){
            window.location.href= response.data?.csv_url;
            setShowExportToastMsg('Export complete')
            setTimeout(() => {
                setShowExportToastMsg('')
            }, 4000);
            setSearchParam(params)
            setShowExportModel(false)
            setExportBtnloading(false)
        }
        else if(response.data.csv_error) { 
            setSearchParam({...params})
            setShowErrorToastMsg('Export failed')

            setTimeout(() => {
                setShowErrorToastMsg('')
            }, 4000);
            setShowExportModel(false)
            setExportBtnloading(false)
        }
            
    }, [searchParam])

    const handleOnClickPageNumber = (pageNum) => {
        const params = Object.fromEntries(searchParam)
        setSearchParam({ ...params, page: pageNum.selected + 1 })
    }

    useEffect(() => {
        setSearchValue(
            searchParam.get('search_term')
                ? decodeURIComponent(searchParam.get('search_term'))
                : ''
        );
    }, [searchParam]);

    /**
     * The function `handleSearch` takes in an event, a key, and a value, and updates the search
     * parameters based on the key-value pair.
     */
    const handleSearch=(e, key, value)=>{
        e.preventDefault();
        let params = Object.fromEntries(searchParam);
        params.page = 1
        if(key === 'search_term') {
            // eslint-disable-next-line security/detect-object-injection
            params[key] = encodeURIComponent(value); 
        }else {
            // eslint-disable-next-line security/detect-object-injection
            params[key] = value
        }
        if(params['search_term'] === ''){ 
            delete params.search_term
            setLoadBids(true);
        }
        setSearchParam({ ...params})
    }
    /**
     * The function `handleSort` is used to update the search parameters based on the sorting key and
     * order.
     */
    const handleSort=(e,key)=>{
        let params = Object.fromEntries(searchParam);
        if(searchParam.get('sort') === false || searchParam.get('sort') === null) {
            params['sort'] = `${key}`
            params['order'] = `ascending`
            setCurrentSortColumn({
                key: key,
                order: 'asc'
            });
        }else {
            if(searchParam.get('sort').includes(key)) {
                if(searchParam.get('order')==='ascending') {
                    params['order'] = `descending`
                    setCurrentSortColumn({
                        key: key,
                        order: 'desc'
                    });
                }else{
                    params['order'] = `ascending`
                    setCurrentSortColumn({
                        key: key,
                        order: 'asc'
                    });
                }
            }else {
                params['sort'] = key
                params['order'] = `ascending`
                setCurrentSortColumn({
                    key: key,
                    order: 'asc'
                });
            }
        }
        setSearchParam({ ...params})
    }

    const deleteBidHandler= async(bid_id)=>{
        const response = await dataService.deleteBid(bid_id);
        if(response.error==false){
            setSuccessMessage("Telephone bid deleted")
            getBids(searchParam.get('page'));
            setTimeout(()=>{
                setSuccessMessage("")
            },4000)
        }else{
            if(response.message && response.message.status==400){
                setUploadErrorMessage(response.message.data.message)
                handleView();
            }else{
                setUploadErrorMessage("Something went wrong. Please try again.")
            }
            setTimeout(()=>{
                setUploadErrorMessage("")
            },4000)
        }
        scrollToTop()
        return response;
    }



    const exportHandler=()=>{
        setExportBtnloading(true)
        let params = Object.fromEntries(searchParam);
        params['bidsExport'] = true
        setSearchParam({...params})
    }

    useEffect(()=>{
        getBids(searchParam.get('page'));
    },[searchParam])

    return(
        <div>

            <ListingHeader searchParam={searchParam} searchValue={searchValue} setSearchParam={setSearchParam}
                setSearchValue={setSearchValue} handleSearch={handleSearch} setShowExportModel={setShowExportModel}
                setShowExportToastMsg={setShowExportToastMsg} data={bids}/>
            {showExoprtToastMsg!=='' && <ToastMeassage message={showExoprtToastMsg}/>}
            {showErrorToastMsg!=='' && <ErrorMessage uploadErrorMessage={showErrorToastMsg}/>}

            <ListingBody currentSortColumn={currentSortColumn} handleSort={handleSort} auctionData={auctionData}
                searchParam={searchParam} bids={bids?.data} searchValue={searchValue} loadBids={loadBids} 
                loading={loading} deleteBidHandler={deleteBidHandler} />

            {(bids?.current_page <= bids?.total_pages) &&
            <div className='pt-[80px]'>
                <Paginate totalPageNumber={Math.ceil(bids.total_records_found/10)}
                    selectedPageNumber={Number(searchParam.get('page')) || 1}
                    handleOnClickPageNumber={handleOnClickPageNumber} />
            </div>
            }
            <Modal setIsOpen={setShowExportModel} isOpen={showExportModel} handleAction={exportHandler}
                loading={exportBtnLoading} buttonText="Export" id="export-btn"
                title="Auction Bid Data" close={true}
                // eslint-disable-next-line max-len
                description="By clicking ‘Export’, you acknowledge your responsibility for the safe handling of this data and agree to comply with all relevant laws and regulations as well as the Indy.auction terms of use and privacy policy."  />
        </div>
    )
}
